import api from '@/axios';

function urlBase64ToUint8Array(base64String) {
  const padding = '='.repeat((4 - base64String.length % 4) % 4);
  const base64 = (base64String + padding)
    .replace(/-/g, '+')
    .replace(/_/g, '/');

  const rawData = window.atob(base64);
  const outputArray = new Uint8Array(rawData.length);

  for (let i = 0; i < rawData.length; ++i) {
    outputArray[i] = rawData.charCodeAt(i);
  }
  return outputArray;
}

export async function subscribeToPush() {
  if (!('serviceWorker' in navigator) || !('PushManager' in window)) {
    console.warn('Push notifications no son soportadas por el navegador.');
    return false;
  }

  try {
    const registration = await navigator.serviceWorker.ready;
    const vapidPublicKey = process.env.VUE_APP_VAPID_PUBLIC_KEY;
    
    if (!vapidPublicKey) {
      console.error("VAPID_PUBLIC_KEY no está definido en las variables de entorno.");
      return false;
    }
    
    const convertedVapidKey = urlBase64ToUint8Array(vapidPublicKey);

    // Solicitar permiso si no ha sido otorgado
    const permission = await Notification.requestPermission();
    if (permission !== 'granted') {
      console.warn('Permiso para notificaciones denegado.');
      return false;
    }

    const subscription = await registration.pushManager.subscribe({
      userVisibleOnly: true,
      applicationServerKey: convertedVapidKey
    });

    const subData = subscription.toJSON();

    // Enviar al Backend Django
    await api.post('notificaciones/suscribir/', {
      subscription: subData,
      browser: navigator.userAgent.includes('Chrome') ? 'Chrome' : 'Web'
    });

    console.log('Suscripción Web Push exitosa.');
    return true;
  } catch (error) {
    console.error('Error al suscribir a notificaciones push:', error);
    return false;
  }
}
